import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const OrganizationContext = createContext(null);

export function OrganizationContextProvider({ children }) {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading]           = useState(true);

  const fetchMe = () => {
    setLoading(true);
    return axios.get("https://api.komorotel.com/api/organization/me", { withCredentials: true })
      .then(r => setOrganization(r.data))
      .catch(() => setOrganization(null))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMe(); }, []);

  return (
    <OrganizationContext.Provider
      value={{ organization, setOrganization, loading, refetch: fetchMe }}
    >
      {children}
    </OrganizationContext.Provider>
  );
}

export const useOrganization = () => useContext(OrganizationContext);
